export const SET_NAVBAR = "SET_NAVBAR"
export const SET_LANG = "SET_LANG"